"use strict"

import {
  eventBus
} from "./eventbus";

import Fsnotific from "./components/dynamic/modalWrapper/FullscreenNotification.vue"
import Vue from 'vue'

export default class NotificationManager {
  constructor(root) {
    this.vueI = root;
  }
  initUserNotificationManager() {
    var idb = this.vueI.dataReferences;
    this.metaCollection = idb.getCollection("userMetaNotifications");
    this.meta = this.metaCollection.find({
      "user": this.vueI.token.idUtente
    })
    this.meta = this.meta && this.meta.length > 0 ? this.meta[0] : this.insertMeta()
    // INIZIALIZZO/RECUPERO IL RECORD CON LE INFORMAZIONI SULLO STATO NOTIFICHE UTENTE
    console.log("META RECORD:")
    console.log(this.meta)
    var include = null
    this.notCollection = idb.getCollection("userNotifications");
    if (this.meta.lastSync) {
      include = this.notCollection.find({
        "user": this.vueI.token.idUtente
      });
      include = include && include.length > 0 ? include : null;
    }
    // alla prima chiamata al ciclo di polling notifico, aggancio anche quelle rimaste pendenti in indexedDB (non eliminate e/o da confermare)
    this.notificationPolling(include);

  }
  notificationPolling(include) {
    var vueI = this.vueI;
    var notI = this;
    var d = !this.meta.lastSync ? null : this.meta.lastSync //data come stringa o null
    var p;
    if (navigator.onLine) {

      p = vueI.microservice({
        role: "notification",
        cmd: "GetUserNotifications",
        params: {
          userId: this.vueI.token.idUtente,
          clientId: this.vueI.token.idCliente,
          clientCat: this.vueI.token.categoriaCliente,
          lastGet: d, 
          ttlDays: 60
        }
      })

      p.then(response => {
        var res = response ? response.body : null;
        var fresh = []
        /* TEST
        res = {"lastGet":"2020-08-06 18:42:25.940",
          "nots":[{"id":2,
            "typ":"Informazione",
            "vis":"Dialogo",
            "start":"2020-08-06 17:01:22.757",
            "end":"2020-08-08 17:01:22.757",
            "con":false,
            "rep":false,
            "del":true,
            "inm":false,
            "obj":{"cmd":"pdf.generator.Order","url":"print/E2744A12-DF50-4FDE-A8F4-E28C51E4633F.pdf","arg":{"des":"4664"}}}
          ]} */
        if (res && res.nots && res.nots.length > 0) {
          for (var i = 0; i < res.nots.length; i++) {
            var not = res.nots[i];
            fresh.push({
              id: not.id,
              richiediConferma: not.con,
              riproponi: not.rep,
              scadenza: not.end,
              eliminabile: not.del,
              tipo: not.typ,
              manuale: not.inm,
              visual: not.vis,
              oggetto: not.obj,
              start: not.start
            })
          }
        }
        // lancio la procedura di analisi notifiche con due flag diversi, in modo da trattar diversamente le nuove notifiche da quelle già presenti in memoria
        this.parseNotifications(fresh, true)
        this.parseNotifications(include, false)
        // REPEAT POLLING -- include null
        setTimeout(function () {
          notI.notificationPolling(null);
        }, 15000);

        // aggiorno la data di Sync nel record di meta informazioni notifiche-utente
        this.meta.lastSync = res.lastGet;
        this.metaCollection.update(this.meta);
      }, err => {
        console.log('GetUserNotifications - error: ', err)
        this.parseNotifications(include, false)
        // REPEAT POLLING -- include null
        setTimeout(function () {
          notI.notificationPolling(null);
        }, 15000);
      });

      p.catch(err => {
        console.log('GetUserNotifications - error: ', err)
        var msg = err && err.body && err.body.error ? err.body.error : ''
        eventBus.$emit('alert', {
          message: "Application caught an error <br> <h5>Details: " + "notification.GetUserNotifications - " + msg +'</h5>',
          type: "error",
          action: ''
        })
      })	

    } else {
      // app offline, parse only saved notifications
      this.parseNotifications(include, false)
    }

  }
  parseNotifications(array, isNew) {
    if (array) {
      for (var i = 0; i < array.length; i++) {
        // elaboro ogni notifica nell'array
        this.parseSingleNotification(array[i], isNew)
      }
      // UPDATE NOTIFICHE TO Pending notifications
      eventBus.$emit("notificationLoop", this.notCollection.data.length);
    }
  }
  parseSingleNotification(not, isNew) {
    var vueI = this.vueI
    var notI = this;

    //TODO:  WIP le scrivo tutte su idb solo se sono nuove
    if (isNew/* && (not.richiediConferma || not.eliminabile)*/) {
      if (Date.now() < Date.parse(not.scadenza)) {
        // nuova notifica, da confermare e/o eliminabile dall'utente, quindi da salvare in idb in modo che sia sempre nella lista delle notifiche
        not["user"] = vueI.token.idUtente
        //controllo se in indexeddb c'è notifica con stesso id e stesso user
        var existing = this.notCollection.find({
          "user": vueI.token.idUtente,
          "id": not.id
        });
        console.log('EXISTING FIRST: ', existing)
        //se si, prima la elimino
        if (existing.length > 0) {
          this.notCollection.findAndRemove({
            "user": vueI.token.idUtente,
            "id": not.id
          });
        }
        //poi inserisco la nuova
        console.log(not)
        not = this.notCollection.insert(not);
        console.log("notification " + not.id + " inserted in indexDB");
        // not riporta il riferimento al record nella collezione ($loki incluso)
      }
    }/*  else if (isNew) { //se non è da confermare o eliminabile dall'utente, la mostrerò solo una volta quindi non devo inserirla nell'idb
      //controllo se in indexeddb c'è notifica con stesso id e stesso user
      var existing = this.notCollection.find({
        "user": vueI.token.idUtente,
        "id": not.id
      });
      console.log('EXISTING: ', existing)
      //se si, la elimino
      if (existing.length > 0) {
        this.notCollection.findAndRemove({
          "user": vueI.token.idUtente,
          "id": not.id
        });
      }
    } */

    if (Date.now() >= Date.parse(not.scadenza)) {
      if (!isNew) {
        // se scaduta e presente in idb (!isNew), elimino la notifica
        this.notCollection.remove(not);
        console.log("notification " + not.id + " removed from indexDB");
      }
    } else {

      // STABILISCO IL TIPO DI NOTIFICA PER LO STILE GRAFICO DEL DIALOG
      var typ = null;
      switch (not.tipo) {
        case "Informazioni":
          typ = "info"
          break;
        case "Informazione":
          typ = "info"
          break;
        case "Errore":
          typ = "error"
          break;
        case "Avviso":
          typ = "warning"
      }

      // STABILISCO LA DEFINIZIONE DEI PULSANTI PER LE NOTIFICHE DIALOG
      if(not.visual == 'Dialogo'){
        var options = {};
        if (not.richiediConferma) {
          options["buttons"] = [
            ['<button>'+vueI.$Jed.translate('Ok')+'</button>', function (instance, toast) {
              instance.hide({transitionOut: 'fadeOutLeft'}, toast, 'buttonName'); // Instance.hide si assicura di chiudere la notifica 
            }, true]
          ];
        }
        if (not.eliminabile) {
          options.buttons = options.buttons ? options.buttons : [];
          options.buttons.push(
            ['<button>'+vueI.$Jed.translate('Delete')+'</button>', function (instance, toast) {
              /*var ok = function(){*/
                console.log("notification " + not.id + " removed from indexDB");
                //rimuovo la notifica da IDB (se il flag eliminabile esiste, il record sarà sicuramente salvato su idb)
                notI.notCollection.remove(not);
                eventBus.$emit("notificationLoop", notI.notCollection.data.length); //resetto le notifiche in attesa di conferma
                instance.hide({transitionOut: 'fadeOutLeft'}, toast, 'buttonName'); // Instance.hide si assicura di chiudere la notifica 
                /*this.close();
              },
              no = function(){
                this.close();
              },
              e = {
                message: vueI.$Jed.firstUpperTranslate('Do you want to delete the notification?'), 
                ok: ok,
                no: no
              }
              eventBus.$emit("confirm", e) */
            }]
          )
        }
      }

      // STABILISCO IL CONTENUTO DELLA NOTIFICA 
      var contenuto = '';
      if(not.manuale){ //il contenuto della notifica è nel file html pubblicato
        var url = front_end_configs.router_url + '/' + front_end_configs.notifications.pubdir + "/"  +"not_"+ not.id + "_" + vueI.token.siglaLingua + ".html" 
        var xobj = new XMLHttpRequest();
        xobj.open('GET', url, false);
        xobj.setRequestHeader("Access-Control-Allow-Origin", '*://*/*');
        xobj.onreadystatechange = function () {
          if (xobj.readyState == 4 && xobj.status == "200") {
            contenuto = xobj.response

            if(not.visual == 'Finestra'){
              var el = document.createElement('span')
              el.id = "fsN"+not.id
              document.body.appendChild(el)

              const componentInstance = new Vue({ 
                ...Fsnotific,
                propsData: {
                  vi: vueI,
                  notifContent: contenuto,
                  uuid: 'fsN-'+not.id,
                  notObj: not
                }
              })
              
              componentInstance.$mount("#fsN"+not.id)
              /* componentInstance.$on('API', function (obj) {
                obj.open()
              }) */
              notI.checkIfShow(isNew, not, null, null, componentInstance)

            }else if(not.visual == 'Dialogo'){
              options["message"] = contenuto
              //vueI.simpleNotification(typ, options)
              notI.checkIfShow(isNew, not, typ, options, null)
            }
          }else if (xobj.status == '404'){
            console.log('NotificationManager - notification '+not.id+': html content not found')
          }
        };
        try {
          xobj.send();
        } catch (e) {
          alert('Problem in getting html file.')
        }
      }else{ //compongo il contenuto della notifica in base al cmd
        if(not.visual == 'Dialogo'){
          if(not.oggetto.cmd == 'pdf.generator.Catalog' || not.oggetto.cmd == 'pdf.generator.Order'){
            if(not.oggetto.err){
              contenuto = vueI.$Jed.firstUpperTranslate('error in the print of %1$s', null, {
                key: null,
                string: [not.oggetto.arg.des]
              }, null)
              console.log('NotificationManager - '+contenuto+': '+not.oggetto.err)
            }else{
              var pdf_link = `<a href='#' onclick='openPdf(${ JSON.stringify(not.oggetto.url) })' style="text-decoration: underline;">PDF</a>`
              if(not.oggetto.cmd == 'pdf.generator.Catalog'){
                contenuto = vueI.$Jed.firstUpperTranslate('%1$s for the print of %2$s is ready', null, {
                  key: null,
                  string: [pdf_link, not.oggetto.arg.des]
                }, null);
              }else if(not.oggetto.cmd == 'pdf.generator.Order'){
                contenuto = vueI.$Jed.firstUpperTranslate('%1$s for the print of the offer request n. %2$s is ready', null, {
                  key: null,
                  string: [pdf_link, not.oggetto.arg.des]
                }, null);
              }
            }
            options["message"] = contenuto
            //vueI.simpleNotification(typ, options)
            this.checkIfShow(isNew, not, typ, options, null)
          }
        }
      }
    }
  }
  insertMeta() {
    return this.metaCollection.insert({
      "user": this.vueI.token.idUtente,
      "lastSync": null
    })
  }
  loopNotification(id, typ, options, loops) { //tempo fa riproponi indicava quante volte rimostrare la notifica! Ora è un "mostra ad ogni avvio"
    var vueI = this.vueI;
    var notI = this;
    setTimeout(function () {
      // se la notifica non è, nel frattempo, stata eliminata (lo verifico ad ogni loop)...
      var target = notI.notCollection.find({
        "user": vueI.token.idUtente,
        "id": id
      });
      target = target ? target[0] : null;
      if (target && target.riproponi) {
        // ... rimostro la notifica
        vueI.simpleNotification(typ, options)
        // ... richiamo la funzione in loop
        notI.loopNotification(id, typ, options, loops)
      } else {
        console.log("notification " + id + " stopped looping")
      }
    }, (loops * 1000))

  }
  mapIndeBool(b) {
    return b == -1
  }
  checkIfShow(isNew, not, typ, options, ci){
    if(isNew){ //se non era già in idb
      if(typ && options){
        this.vueI.simpleNotification(typ, options)
      }else if(ci){
        ci.$on('API', function (obj) {
          obj.open()
        })
      }
    }else if(!isNew && not.riproponi){ //se è già presente in idb e ha il flag riproponi
      if(typ && options){
        this.vueI.simpleNotification(typ, options)
      }else if(ci){
        ci.$on('API', function (obj) {
          obj.open()
        })
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/NotificationManager.js